import "@babel/polyfill";
import $ from "jquery";
import "select2";
import "select2/dist/css/select2.css";

export default () => {
  $(document).ready(function() {
    $(".js-trainings-select").select2({
      minimumResultsForSearch: Infinity,
      width: "resolve"
    });
  });

  var dropdown = null;
  const trainingsForfilter = document.querySelector("#trainings-for-filter");
  const trainingsCategoryfilter = document.querySelector(
    "#trainings-category-filter"
  );
  const moreTrainings = document.querySelectorAll(
    ".swiper-slide[data-for][data-category]"
  );
  const dropdownWrapper = document.querySelector(".js-toggle-dropdown");
  if (dropdownWrapper)
    dropdown = dropdownWrapper.querySelector(".for-dropdown__heading");

  if (dropdown) {
    dropdown.addEventListener("click", e => {
      e.preventDefault();
      if (dropdownWrapper.classList.contains("active")) {
        dropdownWrapper.classList.remove("active");
      } else {
        dropdownWrapper.classList.add("active");
      }
    });
  }
  var forcat = "";
  var cat = "";

  if (trainingsForfilter) {
    forcat = trainingsForfilter.value;
    cat = trainingsCategoryfilter.value;
  }

  const filterTrainings = function() {
    const noTrainings = document.querySelector(".no-trainings");
    var counterShowable = 0;

    moreTrainings.forEach(training => {
      if (
        /*training.dataset.for == forcat &&*/ training.dataset.category.includes(
          cat
        )
      ) {
        training.classList.remove("hidden");
        counterShowable++;
      } else {
        if (!training.classList.contains("hidden")) {
          training.classList.add("hidden");
        }
      }
    });
    if(noTrainings){
      if (counterShowable == 0) {
        noTrainings.classList.remove("hidden");
      } else {
        noTrainings.classList.add("hidden");
      }
    }
  };

  filterTrainings();

  $("#trainings-for-filter").change(function() {
    forcat = $("#trainings-for-filter").select2("data")[0].id;
    //filterTrainings()
  });
  $("#trainings-category-filter").change(function() {
    cat = $("#trainings-category-filter").select2("data")[0].id;
    filterTrainings();
  });
};
